import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Footer.css';
import poweredByStravaLogo from '../assets/strava/api_logo_pwrdBy_strava_horiz_black.svg';

function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="footer">
            <div className="footer-content">
                <p className="footer-copyright">© 2025 Mythic Maps. {t('footer.rightsReserved', 'All rights reserved.')}</p>
                
                <div className="footer-legal-links">
                    <Link to="/privacy-policy">{t('footer.privacyPolicy', 'Privacy Policy')}</Link>
                    <Link to="/cookie-policy">{t('footer.cookiePolicy', 'Cookie Policy')}</Link>
                    <Link to="/terms-of-service">{t('footer.termsOfService', 'Terms of Service')}</Link>
                </div>
                
                <div className="strava-attribution">
                    <img src={poweredByStravaLogo} alt="Powered by Strava" className="strava-logo" />
                </div>
            </div>
        </footer>
    );
}

export default Footer;

